import React from 'react';
import Bugsnag from '@bugsnag/js';
import { t } from 'localization/utils/t';

const TP = 'checkout.components.ErrorBoundary';

// copied from React docs - if we need something more robust, maybe use `react-error-boundary`?
interface ErrorBoundaryProps {
  children: React.ReactNode;
}

export class ErrorBoundary extends React.Component<ErrorBoundaryProps, { hasError: boolean }> {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    Bugsnag.notify(error, (event) => {
      event.severity = 'error';
      event.context = 'Checkout:ErrorBoundary';
      event.addMetadata('checkout', { error: errorInfo });
    });
  }

  render() {
    const { hasError } = this.state;
    if (hasError) {
      // You can render any custom fallback UI
      return <div>{t(`${TP}.fallbackErrorMessage`, 'Oops, something went wrong')}</div>;
    }

    const { children } = this.props;

    return children;
  }
}
